import React, { ReactElement } from "react";
import "./GameScreen.css";

type DeckPilesProps = {
  drawSize: number;
  discardSize: number;
};

type PileProps = {
  label: string;
  count: number;
  kind: "draw" | "discard";
};

/** Number of card backs drawn in the stack, so that a big pile looks bigger than a small one. */
function layers(count: number): number {
  if (count <= 0) return 0;
  if (count <= 4) return 1;
  if (count <= 9) return 2;
  return 3;
}

export function Pile(props: PileProps): ReactElement {
  const n = layers(props.count);
  return (
    <div className={"dp-pile dp-" + props.kind} aria-label={props.label + ": " + props.count + " cards"}>
      <div className="dp-stack">
        {n === 0 && <div className="dp-empty" />}
        {Array.from({ length: n }).map((_, i) => (
          <div key={i} className="dp-layer" style={{ transform: "translate(" + i * 4 + "px, " + -i * 4 + "px)" }} />
        ))}
        {/* key restarts the pop animation whenever the number changes */}
        <div key={props.count} className="dp-count">
          {props.count}
        </div>
      </div>
      <div className="dp-label">{props.label}</div>
    </div>
  );
}

/** The draw and discard piles with the number of cards in each. */
export default function DeckPiles(props: DeckPilesProps): ReactElement {
  return (
    <div className="dp">
      <Pile label="Draw pile" count={props.drawSize} kind="draw" />
      <Pile label="Discard pile" count={props.discardSize} kind="discard" />
    </div>
  );
}
